import { BaseFetch } from "../main-model"
export default class ReportTrainingModel extends BaseFetch {
    getReportTrainningBy = (data) =>
    this.authFetch({
      url: "report-training/getReportTrainningBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportTrainningYear = (data) =>
    this.authFetch({
      url: "report-training/getReportTrainningYear",
      method: "POST",
      body: JSON.stringify(data),
    })
}
